import { useEffect, useState } from 'react';
import { CircularProgress, Fade } from '@material-ui/core';
import cx from 'classnames';

import styles from './SuspenseFallbackPopup.module.css';

const DEFAULT_SPINNER_DELAY = 100;

interface Props {
  className?: string;
  spinnerDelay?: number;
}

export const SuspenseFallbackPopup = ({
  className,
  spinnerDelay = DEFAULT_SPINNER_DELAY,
}: Props) => {
  const [spinnerVisible, setSpinnerVisible] = useState(!(spinnerDelay > 0));

  useEffect(() => {
    if (!spinnerDelay) {
      return;
    }

    setSpinnerVisible(false);
    const timer = setTimeout(() => setSpinnerVisible(true), spinnerDelay);
    return () => clearTimeout(timer);
  }, [spinnerDelay]);

  return (
    <div className={cx(styles.root, className)}>
      {spinnerVisible && (
        <Fade in>
          <div className={styles.panel}>
            <CircularProgress size={40} />
          </div>
        </Fade>
      )}
    </div>
  );
};

SuspenseFallbackPopup.displayName = 'SuspenseFallbackPopup';
